export const REDI_COLORS = {
  orange: '#ea5b25',
  teal: '#58ADC5',
};
